<template>
  <img v-if="photo && !broken" :src="photo" alt="" class="object-cover" @error="broken = true" />
  <span v-else class="flex items-center justify-center bg-[#ecd79f] text-[#1c4848] font-bold" aria-hidden="true">{{ initials }}</span>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useAuthStore } from '@/store/auth/index.js';

/** The signed-in person: their photo, or their initials until they add one. */
const auth = useAuthStore();
const broken = ref(false);
const photo = computed(() => auth.getProfilePhoto);
const initials = computed(() => {
  const user = auth.user?.data;
  return [user?.first_name, user?.last_name].filter(Boolean).map((n) => n.trim()[0]).join('').toUpperCase() || '·';
});

watch(photo, () => { broken.value = false; });
</script>
